import {createFeatureSelector, createSelector} from '@ngrx/store';
import * as fromFiltersConfig from './filters-config.reducer';

export const selectFiltersConfigState = createFeatureSelector<fromFiltersConfig.FiltersConfig>(
  fromFiltersConfig.filtersConfigFeatureKey
);

export const selectBrands = createSelector(
  selectFiltersConfigState, state => state.brands);

export const selectCategories = createSelector(
  selectFiltersConfigState, state => state.categories);

export const selectSegmentMainTypes = createSelector(
  selectFiltersConfigState, state => state.segmentMainTypes);

export const selectSegmentSubTypes = createSelector(
  selectFiltersConfigState, state => state.segmentSubTypes);

export const selectSegmentAudienceTypes = createSelector(
  selectFiltersConfigState, state => state.segmentAudienceTypes);
